import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=13c0051a&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=13c0051a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c0051a",
  null
  
)

export default component.exports